import React, { Component } from "react";
import {
  withStyles,
  CircularProgress,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  TextareaAutosize,
} from "@material-ui/core";
import clsx from "clsx";
import {
  __getMessageId,
  __getNotes,
  __getStatus,
  __getTrackStatusByID,
  __setStatus,
} from "../../utils/utils";
import { connect } from "react-redux";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import { styles } from "../ClearanceForm.css";
import { GrUserAdmin } from "react-icons/gr";
import {
  postItem,
  refreshitems,
  removeTrackHistory,
  removeTrackHistoryAll
} from "../../../redux/actions/MlLicFormContentActions";

import {
  __updateCfStatus,
  localRefreshTrackingMeta,
} from "../../../modules/ml-licensing/clearance-form/Utils";
import { withRouter } from "react-router-dom";
import { loadRuntime } from "../../../redux/actions/ClearanceRuntimeActions";
import CloseIcon from "@material-ui/icons/Close";
import { __trackStatus } from "../../../_clearance/definition/status";
import HelpWrap from "../../../modules/ml-admin/help-admin/help-view/HelpWrap";
import { helpModules } from "../../../modules/ml-admin/help-admin/help-view/Const";
import { validateAaminOverride } from "../../../util/validations/AdminOverrideValidation";
import {
  removeHistory
} from "../../../redux/actions/MlLicFormActions";
import {
  removeTrackSearchkHistory,
  removeTrackSearchkHistoryAll
} from "../../../redux/actions/MlTrackLibraryActions";
import {
  clearDownloads,
  updateDownloads,
} from "../../../redux/actions/DownloadActions";
import Confirm from "../../../util/Confirm";
import { MdCopyright } from "react-icons/md";


class ClearanceOverride extends Component {
  canOverride = false;
  constructor(props) {
    super();
    this.state = {
      toStatus: "",
      withNotes: "",
      posting: "",
      errors: {},
      dialogOpen: false,
      confirmOpen: false,
      userOverrideOpen: false,
    };

    const {
      orgRuntime: {
        runtime: {
          _mlLicensing,
          _mlLicensingOverideRestrictions,
          _mlLicensingOverideRestrictionsOptions
        }
      },
    } = props;

    this.canOverride = _PermittedContent([_mlLicensing, _mlLicensingOverideRestrictions,], _mlLicensingOverideRestrictionsOptions.yes.id) === _mlLicensingOverideRestrictionsOptions.yes.id ? true : false;
  }

  componentDidMount() {
    const {
      runtime: { loading, errors, runtime },
      loadRuntime,
    } = this.props;

    if (!loading && !runtime && !errors) {
      loadRuntime(null);
    }
  }

  componentWillUnmount() {
    const { setBlockRefresh, closePopupOnRefresh, mllicformcontent: {closeOnRefresh, refreshBlockingPopup } } = this.props;
    if(closeOnRefresh || refreshBlockingPopup){
      if (setBlockRefresh) setBlockRefresh(false);
      if (closePopupOnRefresh) closePopupOnRefresh();
    }
  }

  handleClose = (e) => {
    const { onClose,onOverride,} = this.props;
    if (onClose) onClose();
    if (onOverride) onOverride();

    this.setState({ dialogOpen: false });
  };

  handleOpen = (e) => {
    const { onOpen } = this.props;
    if (onOpen) onOpen();
    this.setState({ dialogOpen: true });
  };

  handleValChange = (event) => {
    event.stopPropagation();
    this.setState({ errors: null, [event.target.name]: event.target.value });
  };

  getStatuses = () => {
    const { runtime } = this.props;
    if (runtime.loading) return [];
    let lreturn = [];
    (runtime?.runtime?._statuses || []).filter(s => !s.migrated).map((v) => {
      lreturn.push({
        id: v.id,
        label: v.name,
      });
    });

    return lreturn;
  };

  getStatus = (status) => {
    const { runtime } = this.props;
    if (runtime.loading) return { name: "", color: "" };
    return __getTrackStatusByID(status, runtime?.runtime?._statuses || []);
  };

  handleOverrride = (event) => {
    const { trackData, clearance } = this.props;

    if ((trackData && trackData?.trackEpisodes?.length > 0) || (clearance && (clearance.addToEpisodeData?.selectedEpisodes?.length > 0 || clearance.addToEpisodeData?.addedList?.length > 0))  ) {
      this.setState({
        confirmOpen: true
      })
    } else {
      this.onOverride(event);
    }
  }

  onOverride = (event) => {
    event.stopPropagation();
    const { toStatus, withNotes } = this.state;
    let errors = validateAaminOverride({ toStatus, withNotes });
    if (errors) {
      this.setState({ errors: errors });
      return;
    }

    let {
      postItem,
      refreshitems,
      mllicformcontent: { items, editing },
      //download: { trackDownloads },
      selectedItems,
      user,
      removeHistory,
      removeTrackHistory,
      removeTrackHistoryAll,
      removeTrackSearchkHistory,
      removeTrackSearchkHistoryAll,
      updateDownloads,
      refreshDownloadLink,
    } = this.props;

    //if from button inside wizard
    const { onOverride, userOverride } = this.props;
    if (onOverride) {
      onOverride({ toStatus, withNotes });
      this.setState({ dialogOpen: false });
      return;
    }

    this.setState({ posting: true });
    
    const postParams= {
      cf: editing.id,
      tracks: items.filter(r => r.clearanceFormId == editing.id && selectedItems.indexOf(r.id) != -1).map(d => d.trackDetails.id),
      status: toStatus,
      notes: withNotes,
      ...(userOverride ? { userOverride : userOverride }: {} )
    }

    postItem(
      'override',
      // userOverride ? 'userOverride': 'override',
      `${userOverride ? 'Refer to Licensing' : 'override'} in progress ...`,
      postParams,
      (data, error) => {
        if (!error) {
          data.updated.map((id) => {
            let index = items.findIndex((v) => v.trackDetails.id === id);
            if (index >= 0) {
              items[index].clearancestatus = toStatus;
              items[index].createdBy = items[index].updatedBy = user.id;
              if(userOverride){
                items[index].userOverridden = 1;
                items[index].userOverriddenWithNotes = withNotes;
              }else{
                items[index].adminOverridden = 1;
                items[index].adminOverriddenWithNotes = withNotes;
              }
              __setStatus(
                editing.clearance,
                toStatus,
                null,
                id,
                true,
                1,
                withNotes
              );
            }
          });
          localRefreshTrackingMeta(editing);
          refreshitems(items);
          removeHistory(editing.id);
          removeTrackHistoryAll(editing.id);
          removeTrackSearchkHistoryAll();
          if (refreshDownloadLink) {
            const { clearDownloads } = this.props;
            clearDownloads();
            // selectedItems.forEach( t =>{
            //  trackDownloads.delete(t)
            //  if(updateDownloads){
            //   updateDownloads({id:t});
            // }
            // })

          }
          this.setState({ posting: false, toStatus: "" }, () => {
            this.handleClose();
          });

        } else {
          this.setState({ errors: errors });
        }
      }
    );
  };

  handleConfirmUserOverride = (event) => {
    const { runtime: { runtime },} = this.props;
    let toStatus = runtime?._config?.CF_USER_OVERRIDE_STATUS || '105';
    this.setState({ 
      userOverrideOpen: false,
      toStatus: `${toStatus}`,
      withNotes: ''
     }, () => {
      this.onOverride(event);
    });
  }

  render() {
    const { inMenu, classes, disableRipple, hideCount, canAutoFocus, isSeriesTrack,
      selectedItems,
      runtime: { loading: runtimeLoding, errors: runtimeErrors },
      mllicformcontent: { editing, closeOnRefresh },
      clearance,
      userOverride,
      setBlockRefresh,
      closePopupOnRefresh,
      disabled,
    } = this.props;
    const { dialogOpen, toStatus, withNotes, posting, confirmOpen, userOverrideOpen } = this.state;

    return (
      <>

        {confirmOpen &&
          <Confirm
            name="clearanceOverrideConfirm"
            classes
            isOpen={confirmOpen}
            title="Confirmation Required"
            content="This action will reset any associated episodes."
            confirm="Yes, Override"
            cancel="No, Cancel"
            onConfirm={(e) => {
              this.setState({ confirmOpen: false }, () => {
                this.onOverride(e)
              });
            }}
            onCancel={() => { this.setState({ confirmOpen: false }, ()=> {this.handleClose()}) }}
          />
        }

        {userOverrideOpen &&
          <Confirm
            name="clearanceUserOverrideConfirm"
            classes
            isOpen={userOverrideOpen}
            title="Confirmation Required"
            content="Are you sure you want to override the current status and refer this track to Licensing for further review?"
            confirm="Yes, Override"
            cancel="No, Cancel"
            onConfirm={(e) => { this.handleConfirmUserOverride(e) }}
            onCancel={() => { this.setState({ userOverrideOpen: false }, ()=> {this.handleClose()}) }}
          />
        }

        {/* Close the clearance form if realtime update triggered */}
        {closeOnRefresh && (dialogOpen || userOverrideOpen) &&
          <Confirm
            name="closeOnRefreshDialogOverride"
            classes
            isOpen={closeOnRefresh || false}
            title={'Clearance Form Updated'}
            content={'This Clearance Form has been updated. Click OK to see the latest changes.'}
            confirm="OK"
            onConfirm={() => {
              if (setBlockRefresh) setBlockRefresh(false, true);
              if (closePopupOnRefresh) closePopupOnRefresh();
              this.handleClose();
            }}
          />
        }

        {!inMenu ? (
          <Button
            className={classes.globalCreateSaveButton}
            disabled={
              selectedItems.length < 1 ||
              !this.canOverride ||
              runtimeLoding ||
              runtimeErrors ||
              isSeriesTrack ||
              disabled || 
              false
            }
            onClick={()=>{
              if (userOverride) {
                this.setState({ userOverrideOpen: true })
              } else {
                this.handleOpen();
              }
              if (setBlockRefresh) setBlockRefresh(true);
            }}
          >
            {userOverride ? 'Refer to Licensing' :'Admin Override'}
            {runtimeLoding && (
              <CircularProgress className={classes.insideLoader} />
            )}
            {runtimeErrors && <span>{" Error"}</span>}
          </Button>
        ) : (
          <MenuItem
            disableRipple={disableRipple ? true : false}
            disabled={
              !editing.id ||
              selectedItems.length < 1 ||
              (!this.canOverride && !userOverride) ||
              runtimeLoding ||
              runtimeErrors ||
              isSeriesTrack ||
              disabled ||
              false
            }
            onClick={()=>{
              if (userOverride) {
                this.setState({ userOverrideOpen: true })
              } else {
                this.handleOpen();
              }
              if (setBlockRefresh) setBlockRefresh(true);
            }}
            autoFocus={canAutoFocus || false}
          >
            
            
            {userOverride ? <><MdCopyright  className={classes.clearanceIcon} /> Refer to Licensing</> :<><GrUserAdmin className={classes.clearanceIcon} /> Admin Override</>}
            {!hideCount && <>({selectedItems.length})</>}
            {runtimeLoding && (
              <CircularProgress className={classes.insideLoader} />
            )}
            {runtimeErrors && <span>{" Error"}</span>}
          </MenuItem>
        )}

        <Dialog
          open={dialogOpen}
          id="admin-override-dialog"
          aria-labelledby="content-request-dialog"
          className={classes.dialogWrapper}
          class="adminOverride"
        >
          <DialogTitle>
            {" "}
            <GrUserAdmin className={classes.clearanceIcon} /> {userOverride ? 'User Override' :'Admin Override'}
            {!hideCount && <>({selectedItems.length})</>}
            <span className={classes.overrideHelp}>
              <HelpWrap config={helpModules.CFormAM_AdminOverride} />
            </span>

          </DialogTitle>
          <DialogContent>
            <div className={classes.globalBlockOverride}>
              <label
                className={classes.globalCreateLabel}
                aria-label="Override to Status"
              >
                to Status
                <span
                  aria-label="Override to Status required"
                  className={classes.reqSymbol}
                >
                  *
                </span>{" "}
                :{" "}
              </label>
              <Select
                variant="outlined"
                name="toStatus"
                id="toStatus"
                inputProps={{
                  id: "selectAdminOverride",
                  "aria-labelledby": "selectAdminOverride",
                }}
                value={toStatus}
                className={classes.globalSelectBox}
                onChange={this.handleValChange}
              >
                {this.getStatuses()
                  .filter(
                    (v) =>
                      v.id != __trackStatus.inprogress.id &&
                      v.id != __trackStatus.norule.id &&
                      v.id != __trackStatus.clearMe.id
                  )
                  .map((v, i) => (
                    <MenuItem value={v.id}>
                      <div
                        className={classes.clearanceSign}
                        style={{
                          backgroundColor: this.getStatus(v.id).color,
                        }}
                      >
                        {" "}
                      </div>
                      <span> {v.label}</span>
                    </MenuItem>
                  ))}
              </Select>

              {this.state.errors && this.state.errors["toStatus"] && (
                <span className={classes.Muierror}>{this.state.errors["toStatus"]}</span>
              )}
            </div>
            <div
              className={clsx(
                classes.overrideTextArea,
                this.state.errors && this.state.errors["withNotes"]
                  ? classes.emptyData
                  : null
              )}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <label
                className={classes.globalCreateLabel}
                aria-label="Override with Notes"
              >
                with Notes :{" "}
              </label>

              <TextareaAutosize
                rowsMax={10}
                value={withNotes}
                name="withNotes"
                aria-label={"Notes"}
                onChange={this.handleValChange}
              />
              {this.state.errors && this.state.errors["withNotes"] && (
                <span className={classes.Muierror}>{this.state.errors["withNotes"]}</span>
              )}
            </div>

            {this.state.errors && this.state.errors["e"] && (
              <span className={classes.Muierror}>{this.state.errors["e"]}</span>
            )}
          </DialogContent>

          <DialogActions>

            <Button
              disabled={posting ? true : false}
              className={classes.globalCreateSaveButton}

              onClick={(e) => this.handleOverrride(e)}
              color="primary"
            >
              OK, Override {posting && <CircularProgress />}
            </Button>
            <Button
              aria-label="Close"
              className={clsx(classes.globalGrayButton)}
              title="Close"
              onClick={() => this.handleClose()}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  mllicformcontent: state.mllicformcontent,
  runtime: state.clearanceRuntime,
  user: state.user,
  download: state.download,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  loadRuntime,
  postItem,
  refreshitems,
  removeHistory,
  removeTrackHistory,
  removeTrackHistoryAll,
  removeTrackSearchkHistory,
  removeTrackSearchkHistoryAll,
  updateDownloads,
  clearDownloads,
})(withStyles(styles)(withRouter(ClearanceOverride)));
